import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export default function MagicLogin() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('working'); // working | ok | error
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const redeem = async () => {
      try {
        const { data } = await axios.post(`${API}/api/auth/magic-login`, { token });
        if (cancelled) return;
        localStorage.setItem('dse-learn-token', data.access_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        setState('ok');
        // Small delay so the user sees the success flash, then jump to dashboard.
        setTimeout(() => { window.location.href = '/dashboard'; }, 900);
      } catch (err) {
        if (cancelled) return;
        setDetail(err?.response?.data?.detail || err.message || 'Magic link failed.');
        setState('error');
      }
    };
    redeem();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-lg border border-slate-100 p-8 text-center" data-testid="magic-login-card">
        {state === 'working' && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-emerald-700 animate-spin" />
            <h1 className="mt-4 text-xl font-bold text-slate-900">Signing you in…</h1>
            <p className="text-sm text-slate-500 mt-1">One tap and you're in.</p>
          </>
        )}
        {state === 'ok' && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-700" />
            <h1 className="mt-4 text-xl font-bold text-emerald-800" data-testid="magic-login-ok">Welcome to Wekeza-Smart!</h1>
            <p className="text-sm text-slate-600 mt-1">Loading your dashboard…</p>
          </>
        )}
        {state === 'error' && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-rose-700" />
            <h1 className="mt-4 text-xl font-bold text-slate-900" data-testid="magic-login-error">Link no longer valid</h1>
            <p className="text-sm text-slate-600 mt-2">{detail}</p>
            <Button onClick={() => navigate('/login')} className="mt-6 w-full h-11 rounded-xl bg-emerald-700 hover:bg-emerald-800">
              Sign in with password
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
